<div  [ngClass]="theme" id="momentWrap" (click)="ExitMoment()">
	<div (click)="showMoment($event,item)" class="contents" *ngFor="let item of momentList;let i = index" [ngClass]="{'pre': i < currentIndex,'next': i > currentIndex}" [ngStyle]="{'background-image':'url(assets/picture/casemission/moment/' +  item  + '.png)' }">
	</div>
	<div class="contents next" [ngStyle]="{'background-image':'url(assets/picture/casemission/moment/' +  momentList[0]  + '.png)' }">
	</div>
  <div class="title" (click)="showMoment($event)">点击图片放大</div>
  <div class="subTitle">{{currentIndex+1}}/{{momentList.length}}</div>
</div>
<div id="momentView" *ngIf="momentFlag" (click)="hideMoment()" [@AnimateShow] [ngStyle]="{'background-image':'url(assets/picture/casemission/moment/' +  momentList[currentIndex]  + '.png)' }">
	<div class="momentContent" *ngIf="momentContent != ''">{{momentContent}}</div>
</div>
<div id="momentTip" *ngIf="tipFlag" [@AnimateShow]>
	<div class="inner">
		左右滑动可以翻图
	</div>
	<div class="bitmap"></div>
	<div class="rectangle"></div>
</div>



// WEBPACK FOOTER //
// ./src/component/momentviewpro/component.momentview-pro.html